export default function Home(props){
    return "Home";
}